/*
 * サブシステム名：マスタ管理
 * 機能名：部材一覧
 */

import DdSubHeader from '@/components/DdSubHeader'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdCodeTextBox from '@/components/DdCodeTextBox.vue'
import DdTextBox from '@/components/DdTextBox.vue'
import DdDropDown from '@/components/DdDropDown.vue'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import date from '@/ddv2.library/date'
import { mapGetters } from 'vuex'

const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')

export default {
  name: 'MstBuzaiList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    selected: [],
    conditions: {
      hinmeiCd: '',
      hinmeiNm: '',
      hacchusakiHinshuKbn: '',
      hinshuSbt: '03'
    },
    page: 1,
    modeKengen: 0
  }),
  components: {
    DdSubHeader,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdCodeTextBox,
    DdTextBox,
    DdDropDown,
    DdIconButtonWithTooltip
  },
  computed: {
    ...mapGetters({
      shubetsuList: 'DDMasters/mstShubetsu',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredBuzaiBunrui () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'TGS012').filter((elem) => {
        return elem
      })
    },

    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.filter(elem => {
        return ['04', '05', '06'].includes(elem.hacchusakiHinshuKbn)
      }).map((elem) => {
        const seikyuRank = this.shubetsuList.filter(function (elem) {
          return elem.sbtShuruiCd === 'SBT003'
        })

        Object.keys(seikyuRank).forEach(key => {
          const column = seikyuRank[key].komoku2
          if (elem[column] === null || elem[column] === undefined) {
            elem[column + 'Disp'] = ''
          } else {
            elem[column + 'Disp'] = filter.numericFormatter(elem[column])
          }
        })

        elem.tankaDisp = elem.tanka ? filter.numericFormatter(elem.tanka) : ''
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        elem.hyojiOrderDisp = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''
        elem.yayoiCategoryCdNm = ![undefined, null, ''].includes(elem.yayoiCategoryCd) ? elem.yayoiCategoryCd + ' ' + elem.yayoiCategoryNm : ''

        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isEditButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      if (this.selected.length === 1) {
        return false
      }
      return true
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('MstHinmeiList.defineHeaderPromise')
            const headerFrom = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: '部材分類', value: 'sagyoBunruiNm' },
              { text: '部材コード', value: 'hinmeiCd' },
              { text: '部材名', value: 'hinmeiNm' },
              { text: '型式', value: 'katashiki' },
              { text: '品番', value: 'hinban' },
              { text: '単位', value: 'tani' },
              { text: '部材金額', value: 'tankaDisp', align: 'end' },
              { text: '弥生商品名', value: 'yayoiShohinNm' },
              { text: '弥生カテゴリ', value: 'yayoiCategoryCdNm' }
            ]
            const headerTo = [
              { text: '適用開始年月日', value: 'tekiyoStartYmdDisp', align: 'center' },
              { text: '適用終了年月日', value: 'tekiyoEndYmdDisp', align: 'center' },
              { text: '表示順', value: 'hyojiOrderDisp', align: 'end' }
            ]
            const headerSeikyuRank = self.shubetsuList.filter(function (elem) {
              return elem.sbtShuruiCd === 'SBT003'
            }).map(function (elem) {
              elem.text = elem.sbtNm
              elem.value = elem.komoku2 + 'Disp'
              elem.align = 'end'
              return elem
            })
            self.headers = [...headerFrom, ...headerSeikyuRank, ...headerTo]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              hinmeiCd: '',
              hinmeiNm: '',
              hacchusakiHinshuKbn: null,
              hinshuSbt: '03'
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstHinmeiList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstHinmeiList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstHinmeiList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstHinmeiList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstHinmeiList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCTgmstd0060/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload
          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              return {
              }
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    clear: function () {
      console.log('clear pushed')
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              hinmeiCd: '',
              hinmeiNm: '',
              hacchusakiHinshuKbn: '',
              hinshuSbt: '03'
            }
            this.searchText = ''
            this.rows = []
            this.selected = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      console.log('onRowEditButtonClick', item)
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/VwCTgmstd0060/download', this.conditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '部材マスタ一覧_' + ts + '.csv'
          elem.click()
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    },
    usableDblClick (item) {
      return 'usable-dblclick'
    }
  }
}
